<template>
  <global-modal
    :active="dialog.isActive"
    @toggleActive="toggleActive"
    classModal="w-full sm:w-3/5"
  >
    <!-- Title -->
    <section class="text-xl font-medium" slot="header">
      Tambah Absensi Baru
    </section>
    <!-- Body -->
    <div class="w-full p-5">
      <form>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <datepicker
              v-model="input.tanggal"
              :format="'yyyy-MM-dd'"
              placeholder="Tanggal Absensi"
              name="tanggal"
              v-validate="'required'"
            >
            </datepicker>
            <span class="text-danger text-sm" v-show="errors.has('tanggal')">{{
              errors.first("tanggal")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <flat-pickr
              v-model="input.jam_mulai"
              class="form-control"
              :config="{
                enableTime: true,
                noCalendar: true,
                dateFormat: 'H:i:ss',
                time_24hr: true
              }"
              :placeholder="'Jam Mulai Bekerja'"
            />
            &nbsp;
            <flat-pickr
              v-model="input.jam_selesai"
              class="form-control"
              :config="{
                enableTime: true,
                noCalendar: true,
                dateFormat: 'H:i:ss',
                time_24hr: true
              }"
              :placeholder="'Jam Selesai Bekerja'"
            />
            <span class="text-danger text-sm" v-show="errors.has('tanggal')">{{
              errors.first("tanggal")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <v-select
              :options="listKeterangan"
              v-model="selectedKeterangan"
              name="keterangan"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('keterangan')"
              >{{ errors.first("keterangan") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="" class="mb-1 flex">Laporan Pelaksanaan Tugas :</label>
            <global-quill-editor
              class="w-full"
              label="Deskripsi Pekerjaan"
              v-model="input.deskripsi"
              name="deskripsi"
              v-validate="'required|min:10'"
            ></global-quill-editor>
            <span
              class="text-danger text-sm"
              v-show="errors.has('deskripsi')"
              >{{ errors.first("deskripsi") }}</span
            >
          </div>
        </div>
      </form>
    </div>
    <section class="p-4 flex justify-end" slot="footer">
      <div>
        <vs-button
          id="confirmAccept"
          class="mx-1"
          color="primary"
          type="filled"
          @click="handleOnSubmit"
        >
          Simpan Absensi
        </vs-button>
        <vs-button
          id="confirmCancel"
          class="mx-1"
          color="danger"
          type="border"
          @click="handleOnCancel"
        >
          Cancel
        </vs-button>
      </div>
    </section>
  </global-modal>
</template>

<script>
// import { digofHttp as axios } from "@/axios";
import vSelect from "vue-select";
import { LIST_KETERANGAN } from "@/query/absensi";
import { CREATE } from "@/query/absensi";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import moment from "moment";

export default {
  components: {
    "v-select": vSelect,
    Datepicker,
    flatPickr
  },
  props: {
    penggunaId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      dialog: {
        isActive: false
      },
      input: {
        pengguna_id: this.$sanctum.getUser().id,
        keterangan: "",
        deskripsi: "",
        tanggal: "",
        jam_mulai: "",
        jam_selesai: ""
      },
      selectedKeterangan: { value: "", label: "Pilih Keterangan Absensi" },
      listKeterangan: LIST_KETERANGAN,
      formValues: {
        files: [],
        removeIds: []
      }
    };
  },
  watch: {
    selectedKeterangan: {
      handler() {
        this.input.keterangan = this.selectedKeterangan.value;
      }
    }
  },
  methods: {
    async handleOnSubmit() {
      try {
        await this.storeAbsensi();
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "Gagal",
          text: "Oops terjadi kesalahan, silahkan hubungi tim IT.",
          color: "danger"
        });
      }
    },
    handleOnCancel() {
      this.toggleActive(false);
    },
    toggleActive(isActive) {
      this.dialog.isActive = isActive;
    },
    async storeAbsensi() {
      await this.$validator.validateAll().then(result => {
        if (result) {
          this.input.tanggal = moment(this.input.tanggal).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          this.$vs.loading();
          this.$apollo
            .mutate({
              mutation: CREATE,
              variables: {
                input: {
                  ...this.input
                }
              }
            })
            .then(response => {
              this.$vs.loading.close();
              const absensiUuid = response.data.absensiCreate.uuid;
              this.$router.push({
                name: "absensi-detail",
                params: { uuid: absensiUuid }
              });
            })
            .catch(error => {
              let { graphQLErrors } = error;
              console.log(graphQLErrors);
              this.$vs.notify({
                color: "danger",
                title: "Terjadi Kesalagan",
                text: "Periksa data anda"
              });
              this.$vs.loading.close();
            });
          // axios({
          //   url: "template-surat/store",
          //   method: "post",
          //   headers: {
          //     "Content-Type": "multipart/form-data"
          //   },
          //   data: this.input
          // })
          // .then(response => {
          //   this.$vs.notify({
          //     title: "Sukses",
          //     text: "Berhasil menambahkan template surat.",
          //     color: "success",
          //     position: "top-right"
          //   });

          //   console.log(response);

          //   // window.setTimeout(() => {
          //   //   this.$router.push({
          //   //     name : 'template-surat-detail',
          //   //     params : {uuid: response.data.data.uuid}
          //   //   });
          //   // },700);
          // }).catch(e => {
          //   console.error(e);
          //   this.$vs.notify({
          //     title: "Gagal",
          //     text: "Terjadi kesalahan, pastikan form sudah lengkap terisi !",
          //     color: "danger",
          //     position: "top-right"
          //   });
          // });
        } else {
          this.$vs.notify({
            title: "Silahkan lengkapi form terlebih dahulu !",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x",
            position: "top-right"
          });
        }
      });
    },
    resetFormValues() {
      this.input.selectedKeterangan = {
        value: "",
        label: "Pilih Keterangan Absensi"
      };
      this.listKeterangan = [];
    }
  }
};
</script>
